import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace CWagsRally {
  export const form: IEventRegisterRow[] = [
    // Starter with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_rally_starter,
          options: [
            { value: Constants.dog_class_element_level.cwags_rally_starter, id: Constants.dog_class_element_level.cwags_rally_starter }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_rally_a, id: Constants.dog_class_section.cwags_rally_a },
            { value: Constants.dog_class_section.cwags_rally_b, id: Constants.dog_class_section.cwags_rally_b },
            { value: Constants.dog_class_section.cwags_rally_to, id: Constants.dog_class_section.cwags_rally_to },
            { value: Constants.dog_class_section.cwags_rally_jr, id: Constants.dog_class_section.cwags_rally_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // Advanced with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_rally_advanced,
          options: [
            { value: Constants.dog_class_element_level.cwags_rally_advanced, id: Constants.dog_class_element_level.cwags_rally_advanced }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_rally_a, id: Constants.dog_class_section.cwags_rally_a },
            { value: Constants.dog_class_section.cwags_rally_b, id: Constants.dog_class_section.cwags_rally_b },
            { value: Constants.dog_class_section.cwags_rally_to, id: Constants.dog_class_section.cwags_rally_to },
            { value: Constants.dog_class_section.cwags_rally_jr, id: Constants.dog_class_section.cwags_rally_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // Pro with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_rally_pro,
          options: [
            { value: Constants.dog_class_element_level.cwags_rally_pro, id: Constants.dog_class_element_level.cwags_rally_pro }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_rally_a, id: Constants.dog_class_section.cwags_rally_a },
            { value: Constants.dog_class_section.cwags_rally_b, id: Constants.dog_class_section.cwags_rally_b },
            { value: Constants.dog_class_section.cwags_rally_to, id: Constants.dog_class_section.cwags_rally_to },
            { value: Constants.dog_class_section.cwags_rally_jr, id: Constants.dog_class_section.cwags_rally_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // Zoom 1 with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_rally_zoom_1,
          options: [
            { value: Constants.dog_class_element_level.cwags_rally_zoom_1, id: Constants.dog_class_element_level.cwags_rally_zoom_1 }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_rally_a, id: Constants.dog_class_section.cwags_rally_a },
            { value: Constants.dog_class_section.cwags_rally_b, id: Constants.dog_class_section.cwags_rally_b },
            { value: Constants.dog_class_section.cwags_rally_to, id: Constants.dog_class_section.cwags_rally_to },
            { value: Constants.dog_class_section.cwags_rally_jr, id: Constants.dog_class_section.cwags_rally_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // Zoom 1.5 with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_rally_zoom_1_5,
          options: [
            { value: Constants.dog_class_element_level.cwags_rally_zoom_1_5, id: Constants.dog_class_element_level.cwags_rally_zoom_1_5 }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_rally_a, id: Constants.dog_class_section.cwags_rally_a },
            { value: Constants.dog_class_section.cwags_rally_b, id: Constants.dog_class_section.cwags_rally_b },
            { value: Constants.dog_class_section.cwags_rally_to, id: Constants.dog_class_section.cwags_rally_to },
            { value: Constants.dog_class_section.cwags_rally_jr, id: Constants.dog_class_section.cwags_rally_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // Zoom 2 with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_rally_zoom_2,
          options: [
            { value: Constants.dog_class_element_level.cwags_rally_zoom_2, id: Constants.dog_class_element_level.cwags_rally_zoom_2 }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_rally_a, id: Constants.dog_class_section.cwags_rally_a },
            { value: Constants.dog_class_section.cwags_rally_b, id: Constants.dog_class_section.cwags_rally_b },
            { value: Constants.dog_class_section.cwags_rally_to, id: Constants.dog_class_section.cwags_rally_to },
            { value: Constants.dog_class_section.cwags_rally_jr, id: Constants.dog_class_section.cwags_rally_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
    // ARF with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.cwags_rally_arf,
          options: [
            { value: Constants.dog_class_element_level.cwags_rally_arf, id: Constants.dog_class_element_level.cwags_rally_arf }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.cwags_rally_a, id: Constants.dog_class_section.cwags_rally_a },
            { value: Constants.dog_class_section.cwags_rally_b, id: Constants.dog_class_section.cwags_rally_b },
            { value: Constants.dog_class_section.cwags_rally_to, id: Constants.dog_class_section.cwags_rally_to },
            { value: Constants.dog_class_section.cwags_rally_jr, id: Constants.dog_class_section.cwags_rally_jr },
            { value: Constants.dog_class_section.feo, id: Constants.dog_class_section.feo }
          ]
        }
      ]
    },
  ];
}
